// extracted by mini-css-extract-plugin
export default {"container":"PackageEditForm_container__lCTyL"};